<app-input
	*ngIf="!disabled"
	(debounce)="updateTitle($event)"
	[ngModel]="document?.title"
	class="mr-3 mb-3"
	label="Document title"
	placeholder="Document title"
></app-input>

<app-html-editor
	class="h-full"
	*ngIf="document"
	[disabled]="disabled"
	[location]="businessLocation"
	[document]="_documentHtml?.html"
	(onChange)="updateContent($event)"
	[debounceTime]="0"
	(onStatusChange)="statusChange($event)"
	(triggerSettings)="toggleDocumentSettings()"
></app-html-editor>
